import React, { useEffect, useRef, useState } from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import { useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import axios from 'axios';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ManagerList from '../../components/Company/ManagerList';

export default function InfoMng() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const auth = useRecoilValue(authAtom);
  const [userInfo, setUserInfo] = useState([]);
  const [dgCds, setDgCds] = useState([]);
  const [sgguCds, setSgguCds] = useState([]);
  const [open, setOpen] = useState(false);

  const password = useRef();
  password.current = watch('userInfo.password');

  const companyUpdate = async (data) => {
    return await axios.patch(`/api/company/${data.id}`, { data });
  };

  const onSubmit = (data) => {
    if (isDirty) {
      if (!data.userInfo.Company.sgguCd) {
        alert('시군구를 선택해주세요.');
        return;
      }
      companyUpdate(data.userInfo.Company)
        .then((response) => {
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getUser = async () => {
    const response = await axios.get(`/api/user/${auth.id}`);
    setUserInfo(response.data);
    setValue('userInfo', response.data);
  };

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, Company: { ...userInfo.Company, [e.target.id]: e.target.value } });
    setValue('userInfo', { ...userInfo, Company: { ...userInfo.Company, [e.target.id]: e.target.value } }, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeDgCdSelect = (e) => {
    setUserInfo({ ...userInfo, Company: { ...userInfo.Company, dgCd: e.target.value } });
    setUserInfo({ ...userInfo, Company: { ...userInfo.Company, sgguCd: null } });
    setValue('userInfo', { ...userInfo, Company: { ...userInfo.Company, dgCd: e.target.value } }, { shouldValidate: true, shouldDirty: true });
  };

  const getDgCodeList = async () => {
    await axios
      .get(`/api/code/dg`)
      .then((response) => {
        if (!!response.data) {
          setDgCds(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getSgguCodeList = async (dgCd) => {
    await axios
      .get(`/api/code/${dgCd}`)
      .then((response) => {
        if (!!response.data) {
          setSgguCds(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleChangeSgguCdSelect = (e) => {
    setUserInfo({ ...userInfo, Company: { ...userInfo.Company, sgguCd: e.target.value } });
    setValue('userInfo', { ...userInfo, Company: { ...userInfo.Company, sgguCd: e.target.value } }, { shouldValidate: true, shouldDirty: true });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(async () => {
    await getSgguCodeList(userInfo.Company?.dgCd);
  }, [userInfo?.Company?.dgCd]);

  useEffect(async () => {
    await getUser();
    await getDgCodeList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        회사 관리
      </Typography>
      <Box id="userInfoForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
        <TextField
          margin="dense"
          required
          fullWidth
          name="companyName"
          label="회사명"
          id="companyName"
          value={userInfo?.Company?.companyName || ''}
          error={!!errors.userInfo?.Company?.companyName}
          helperText={errors.userInfo?.Company?.companyName && errors.userInfo?.Company?.companyName.message}
          {...register('userInfo.Company.companyName', {
            required: '회사명을 입력해주세요.'
          })}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          required
          fullWidth
          name="companyNo"
          label="사업자등록번호"
          id="companyNo"
          value={userInfo?.Company?.companyNo || ''}
          error={!!errors.userInfo?.Company?.companyNo}
          helperText={errors.userInfo?.Company?.companyNo && errors.userInfo?.Company?.companyNo.message}
          {...register('userInfo.Company.companyNo', {
            required: '사업자등록번호를 입력해주세요.',
            pattern: { value: /\d/, message: '숫자만 입력해주세요.' }
          })}
          onChange={handleChange}
        />
        <FormControl sx={{ minWidth: 1 / 2 }}>
          <InputLabel id="dgCd-label" required>
            시도
          </InputLabel>
          <Select labelId="dgCd-label" id="dgCd" name="dgCd" value={userInfo?.Company?.dgCd || ''} label="시도" onChange={handleChangeDgCdSelect}>
            {dgCds.map((item, idx) => {
              return (
                <MenuItem key={`dgCd-${idx}`} value={item.cdVal}>
                  <ListItemText primary={item.cdNm} />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 1 / 2 }}>
          <InputLabel id="sgguCd-label" required>
            시군구
          </InputLabel>
          <Select labelId="sgguCd-label" id="sgguCd" name="sgguCd" value={userInfo?.Company?.sgguCd || ''} label="시군구" onChange={handleChangeSgguCdSelect}>
            {sgguCds.map((item, idx) => {
              return (
                <MenuItem key={`sgguCd-${idx}`} value={item.cdVal}>
                  <ListItemText primary={item.cdNm} />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <Button variant="contained" type="submit" fullWidth sx={{ mt: 1 }}>
          수정
        </Button>
        <Divider sx={{ mt: 5, mb: 2 }} />
        <Typography component="h6" variant="h6" color="primary" gutterBottom>
          수석 매니저
        </Typography>
        <TextField margin="dense" required fullWidth name="topManagerId" label="아이디" id="topManagerId" value={userInfo?.Company?.managerId || ''} disabled={true} />
        <TextField margin="dense" required fullWidth name="topManagerName" label="이름" id="topManagerName" value={userInfo?.Company?.managerName || ''} disabled={true} />
        <TextField margin="dense" required fullWidth name="topManagerMail" label="이메일" id="topManagerMail" value={userInfo?.Company?.managerMail || ''} disabled={true} />
        {userInfo?.Company?.topManagerId === auth.id && (
          <Button variant="contained" form="userInfoForm" fullWidth onClick={handleClickOpen}>
            변경
          </Button>
        )}
      </Box>
      <ManagerList open={open} handleClose={handleClose} companyId={userInfo.Company?.id} topManagerId={userInfo?.Company?.topManagerId} getUser={getUser} />
    </Paper>
  );
}
